
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/community",
      function () {
        return require("private-next-pages/community.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/community"])
      });
    }
  